const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

class ProposalService {
  getAuthToken() {
    return localStorage.getItem('token');
  }

  getHeaders() {
    const token = this.getAuthToken();
    return {
      'Content-Type': 'application/json',
      ...(token && { 'Authorization': `Bearer ${token}` })
    };
  }

  async getProposals(params = {}) {
    try {
      const queryParams = new URLSearchParams();
      Object.keys(params).forEach(key => {
        if (params[key] !== undefined && params[key] !== '') {
          queryParams.append(key, params[key]);
        }
      });

      const response = await fetch(`${API_BASE_URL}/api/proposals?${queryParams}`, {
        headers: this.getHeaders()
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.message || 'Error al obtener las propuestas');
      return data;
    } catch (error) {
      console.error('Error en getProposals:', error);
      throw error;
    }
  }

  async getProposalById(id) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/proposals/${id}`, {
        headers: this.getHeaders()
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.message || 'Error al obtener la propuesta');
      return data;
    } catch (error) {
      console.error('Error en getProposalById:', error);
      throw error;
    }
  }

  async createProposal(proposalData) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/proposals`, {
        method: 'POST',
        headers: this.getHeaders(),
        body: JSON.stringify(proposalData),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.message || 'Error al crear la propuesta');
      return data;
    } catch (error) {
      console.error('Error en createProposal:', error);
      throw error;
    }
  }

  async updateProposal(id, proposalData) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/proposals/${id}`, {
        method: 'PUT',
        headers: this.getHeaders(),
        body: JSON.stringify(proposalData),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.message || 'Error al actualizar la propuesta');
      return data;
    } catch (error) {
      console.error('Error en updateProposal:', error);
      throw error;
    }
  }

  async generateWithAI(id, message = '') {
    try {
      const response = await fetch(`${API_BASE_URL}/api/proposals/${id}/generate`, {
        method: 'POST',
        headers: this.getHeaders(),
        body: JSON.stringify({ message }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.message || 'Error al generar con IA');
      return data;
    } catch (error) {
      console.error('Error en generateWithAI:', error);
      throw error;
    }
  }

  async convertToSale(id, data = {}) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/proposals/${id}/convert-to-sale`, {
        method: 'POST',
        headers: this.getHeaders(),
        body: JSON.stringify(data),
      });
      const responseData = await response.json();
      if (!response.ok) throw new Error(responseData.message || 'Error al convertir a venta');
      return responseData;
    } catch (error) {
      console.error('Error en convertToSale:', error);
      throw error;
    }
  }

  async approveStage(id, data = {}) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/proposals/${id}/approve-stage`, {
        method: 'POST',
        headers: this.getHeaders(),
        body: JSON.stringify(data),
      });
      const responseData = await response.json();
      if (!response.ok) throw new Error(responseData.message || 'Error al aprobar etapa');
      return responseData;
    } catch (error) {
      console.error('Error en approveStage:', error);
      throw error;
    }
  }

  async deleteProposal(id) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/proposals/${id}`, {
        method: 'DELETE',
        headers: this.getHeaders()
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.message || 'Error al eliminar la propuesta');
      return data;
    } catch (error) {
      console.error('Error en deleteProposal:', error);
      throw error;
    }
  }

  async aiChat(message, chatHistory = [], userRole = '') {
    try {
      const response = await fetch(`${API_BASE_URL}/api/proposals/ai/chat`, {
        method: 'POST',
        headers: this.getHeaders(),
        body: JSON.stringify({ message, chatHistory, userRole }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.message || 'Error en el chat con IA');
      return data;
    } catch (error) {
      console.error('Error en aiChat:', error);
      throw error;
    }
  }
}

export default new ProposalService();
